import { React, useState, useRef, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import "../styles/secondpage.css";
import "../styles/secondpage-responsive.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RoleSelectionModal from "../components/RoleSelectionModal";
import { useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosInstance';

function Secondpage() {
  const [isMonthly, setIsMonthly] = useState(true);
  const [packages, setPackages] = useState([]); // State for packages
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false); // show on page load
  const navigate = useNavigate();

  const form = useRef("Full_Name", "email");

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await axiosInstance.get("/doctor/signup/packages/");
        // Combine doctor_packages and clinic_packages into a single array
        const combinedPackages = [
          ...response.data.data.doctor_packages.map(pkg => ({
            id: pkg.id,
            name: pkg.name,
            description: pkg.type, // Assuming type is used as description
            price: pkg.price,
          })),
          ...response.data.data.clinic_packages
            // Filter out the package with PackId 164 (Virtual Triage Free Trial)
            .filter(pkg => pkg.PackId !== 164)
            .map(pkg => ({
              id: pkg.PackId,
              name: pkg.PackName,
              description: pkg.PackDescription,
              price: pkg.PackPrice,
            })),
        ];
        setPackages(combinedPackages); // Set the combined packages
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };

    fetchPackages();
  }, []);

  const handleGetStartedClick = (pkg) => {
    // Redirect based on package type
    if (pkg.name === "Basic Monthly" || pkg.name === "Basic Yearly") {
      navigate("/doctor-signup", { state: { packageDetails: pkg.id, packageName: pkg.name, packagePrice: pkg.price } });
      console.log("Package Details", pkg.id, pkg.name, pkg.price);
    } else if (pkg.name === "Standard Monthly" || pkg.name === "Standard Yearly" || pkg.name === "Premium Monthly" || pkg.name === "Premium Yearly") {
      navigate("/clinic_register", { state: { packageDetails: pkg } });
    }
  };

  return (
    <div className="secondpage-container">
      <Navbar />
      {/* Main Banner */}
      <section className="banner">
        <div className="banner-text">
          <h1>
            Empower Your Health and Wellness Practice with AI-Driven Virtual
            Care.
          </h1>
          <p>
            Offer professional, secure consultations with our AI-powered
            platform. Virtual Triage helps you automate tasks, track
            consultations, reduce admin work, and deliver exceptional care
            anytime, anywhere.
          </p>
          <button className="get-started-btn"  onClick={() => setIsModalOpen(true)}>Get Started →</button>
        </div>
        <RoleSelectionModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        <div className="banner-image">
          <img src="../assets/practitioner side.png" alt="Mobile UI" />
        </div>
      </section>

      {/* Features Section */}
      <section className="secondpage-features-section">
        <div className="secondpage-features-img">
          <img src="./assets/visuals-1.png" alt="Features" />
        </div>
        <div className="secondpage-features-text">
          <h2>Our Features</h2>
          <p>
            Few good reasons why you should use Virtual Triage as your health
            and wellness assistant.
          </p>
          <div className="secondpage-features">
            <div className="secondpage-feature-item">
              <img src="./assets/human.svg" alt="AI-Powered Symptom Checker" />
              <span>AI-Powered Symptom Checker</span>
            </div>
            <div className="secondpage-feature-item">
              <img
                src="./assets/virtualcall.svg"
                alt="Global Virtual Consultations"
              />
              <span>Global Virtual Consultations</span>
            </div>
            <div className="secondpage-feature-item">
              <img
                src="./assets/calendar.svg"
                alt="Easy Appointment Management"
              />
              <span>Easy Appointment Management</span>
            </div>
            <div className="secondpage-feature-item">
              <img src="./assets/e-payment.svg" alt="Secure E-Payments" />
              <span>Secure E-Payments</span>
            </div>
          </div>
        </div>
      </section>
      {/* Platform Features */}
      <section className="platform-features">
        <h2>The Virtual Triage Platform Features</h2>
        <button className="get-started-btn"  onClick={() => setIsModalOpen(true)}>Get Started →</button>
        <div className="feature-cards">
          <div className="feature-card">
            <div className="icon">
              <img src="./assets/human.svg" alt="AI-Powered Symptom Analysis" />
            </div>
            <h3>AI-Powered Powered Precision</h3>
            <p>
              Unlike other platforms, Virtual Traige's AI is built specifically
              for healthcare, offering deeper symptom analysis and more accurate
              practitioner recommendations.
            </p>
          </div>
          <div className="feature-card">
            <div className="icon">
              <img
                src="./assets/virtualcall.svg"
                alt="E-Payments & E-Prescriptions"
              />
            </div>
            <h3>Streamlined Operations</h3>
            <p>
              Automate administrative tasks like appointment scheduling, symptom
              analysis, and client inquiries with our healthcare-trained AI.
            </p>
          </div>
          <div className="feature-card">
            <div className="icon">
              <img
                src="./assets/icon-5.svg"
                alt="E-Payments & E-Prescriptions"
                style={{ scale: "0.7" }}
              />
            </div>
            <h3>Marketplace for Global Healthcare Providers</h3>
            <p>
              A marketplace where users find experts, and professionals showcase
              their services.
            </p>
          </div>
          <div className="feature-card">
            <div className="icon">
              <img
                src="./assets/calendar.svg"
                alt="E-Payments & E-Prescriptions"
              />
            </div>
            <h3>Cost & Time Saving</h3>
            <p>
              By reducing manual tasks and overhead, Virtual Triage saves time
              and costs, making health and wellness more efficient and
              accessible.
            </p>
          </div>
        </div>
      </section>

      {/* Pricing Plans */}
      <section className="pricing-plans">
        <h2>Pick your preferred plan</h2>
        <p>
          Flexible pricing plans designed to fit your needs. Choose the plan
          that works best for you and start delivering quality care today.
        </p>
        {/* Toggle Button */}
        <div className="toggle-switch">
          <button
            className={isMonthly ? "active" : ""}
            onClick={() => setIsMonthly(true)}
          >
            Monthly
          </button>
          <button
            className={!isMonthly ? "active" : ""}
            onClick={() => setIsMonthly(false)}
          >
            Yearly
          </button>
        </div>
        <p style={{ color: "black" }}>
          Upto <strong>16% OFF</strong> on Yearly Plans!
        </p>
        <div className="plans">
          {packages
            .filter(pkg => (isMonthly ? pkg.price <= 998 : pkg.price > 998)) // Filter based on toggle
            .map((pkg) => (
              <div className="plan-card" key={pkg.id}>
                <h3>{pkg.name}</h3>
                <p className="price">
                £{isMonthly ? pkg.price : pkg.price }
                  <span style={{ fontSize: "18px" }}>
                    {" "}
                    / {isMonthly ? "month" : "year"}
                  </span>
                </p>
                <p>{pkg.description || "Package description not available."}</p>
                <ul>
                  <li>Practitioner Portal</li>
                  <li>Clinic Portal</li>
                  <li>Unlimited Appointments</li>
                  <li>In App messaging</li>
                  <li>Video Calling</li>
                  <li>Advanced App. Management</li>
                  <li>Visibility to patient's map</li>
                  <li>Healthcare trained AI chat bot</li>
                </ul>
                <button className="pricing-get-started-btn" onClick={() => handleGetStartedClick(pkg)}>
                  Get Started
                </button>
              </div>
            ))}
        </div>
      </section>
      
      {/* Why Listing Yourself Matters Section */}
      <section className="why-listing-section">
        <div className="why-listing-container">
          <div className="why-listing-left">
            <h2 className="why-listing-title">Why Listing Yourself Matters?</h2>
            <p className="why-listing-desc">
              In today's digital-first healthcare world, visibility = credibility. Listing yourself opens the door to career growth and global reach for less than a sandwich a month, just <b>£19.99/month</b>.
            </p>
            <ul className="why-listing-list">
              <li><FaCheckCircle className="why-listing-check"/> <b>Gain exposure</b> &nbsp;to patients globally, not just locally.</li>
              <li><FaCheckCircle className="why-listing-check"/> <b>Attract more consultations</b> &nbsp;with higher discoverability.</li>
              <li><FaCheckCircle className="why-listing-check"/> <b>Build a loyal</b>, expanding patient base over time.</li>
              <li><FaCheckCircle className="why-listing-check"/> <b>Strengthen your personal brand</b>&nbsp;and stand out professionally.</li>
          </ul>
            <p className="why-listing-desc">All this for just <b>£19.99/month</b>, a small price for something that actually adds value.</p>
            <a href="https://virtualtriage.co/home-page" style={{textDecoration: 'none', textAlign: '-webkit-center'}}>
            <button className="why-listing-btn"><FaCheckCircle style={{marginRight: 8}}/> List Yourself!</button>
            </a>
          </div>
          <div className="why-listing-right">
            <img src={process.env.PUBLIC_URL + "/assets/Asset 4.png"} alt="Why Listing Yourself Matters" className="why-listing-img" />
        </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Secondpage;
